import { render, staticRenderFns } from "./MdAchievement.vue?vue&type=template&id=4a785423&"
import script from "./MdAchievement.vue?vue&type=script&lang=js&"
export * from "./MdAchievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports